
import React from "react";
import Navbar from "@/components/Navbar";
import HomePage from "@/components/HomePage";
import Footer from "@/components/Footer";
import { PropertyCorrectionsProvider } from "@/contexts/PropertyCorrectionsContext";

const Index = () => {
  return (
    <PropertyCorrectionsProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <HomePage />
        </main>
        <Footer />
      </div>
    </PropertyCorrectionsProvider>
  );
};

export default Index;
